import { render, staticRenderFns } from "./preferredBrandGoodCategoryList.vue?vue&type=template&id=958470a2&scoped=true"
import script from "./preferredBrandGoodCategoryList.vue?vue&type=script&lang=js"
export * from "./preferredBrandGoodCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958470a2",
  null
  
)

export default component.exports